// Libraries
import styled from 'styled-components'

// Components
import { Aligner, FormButton } from 'heeds-ds'

type ButtonProps = {
  active?: boolean
}

export const AddSpecialSeriesButton = styled(FormButton).attrs(() => ({
  margin: '24px auto 0',
  size: 'small',
  variation: 'borderless',
}))``

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  padding: 0 2.4rem 14.2rem;
  width: 100%;
`

export const FiltersContainer = styled.div`
  display: flex;
  gap: 8px;
  margin: 10px 0 0;
  overflow-x: scroll;
`

export const Form = styled.form``

export const SearchContainer = styled(Aligner).attrs(() => ({
  align: 'flex-start',
  gap: '16px',
}))`
  width: 100%;
`

export const TagButton = styled.button<ButtonProps>`
  align-items: center;
  background: ${({ active, theme }) =>
    active ? theme.colors.icon.default : theme.colors.icon.onPrimary};
  display: flex;
  border-radius: 15px;
  border: 1px solid
    ${({ active, theme }) =>
      active ? theme.colors.border.default : theme.colors.border.input};
  color: ${({ active, theme }) =>
    active ? theme.colors.text.onPrimary : theme.colors.text.subdued};
  font-family: ${({ theme }) => theme.fontFamily.roboto};
  font-size: ${({ theme }) => theme.fontSize.copy4};
  gap: 8px;
  padding: 8px 16px;
  white-space: nowrap;
`
